export default "__VITE_ASSET__CTFEoNwL__"